import { apiSlice } from "../../app/api/apiSlice";

export const groupApislice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createGroup: builder.mutation({
      query: (groupData) => ({
        url: "/group/create",
        method: "POST",
        body: groupData,
      }),
      invalidatesTags: [{ type: "Group", id: "LIST" }],
    }),

    updateGroup: builder.mutation({
      query: (groupData) => ({
        url: "/updateGroup/update",
        method: "PUT",
        body: groupData,
      }),
      invalidatesTags: [{ type: "Group", id: "LIST" }],
    }),

    deleteGroup: builder.mutation({
      query: ({ groupId }) => ({
        url: "/deletegroup/delete",
        method: "DELETE",
        body: { groupId },
      }),
      invalidatesTags: [{ type: "Group", id: "LIST" }],
    }),

    getAllGroups: builder.query({
      query: () => ({
        url: "/getgroups/Allgroup",
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Group", id: _id })),
              { type: "Group", id: "LIST" },
            ]
          : [{ type: "Group", id: "LIST" }],
    }),

    getSingleGroup: builder.mutation({
      query: (groupData) => ({
        url: "/getgroups/group",
        method: "POST",
        body: groupData,
      }),
    }),
  }),
});

export const {
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useGetSingleGroupMutation,
  useGetAllGroupsQuery,
} = groupApislice;
